import axios from "axios";

const getAllDepositos = async () => {
  const nic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const serialNumberKeyClover = localStorage.getItem("serialNumberKeyClover");

  try {
    const headers = { "Content-Type": "application/json" };
    const body = { nic, token, serialNumberKeyClover };

    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/Depositos/GetAllDepositos`, body, { headers });
    return data;
  } catch (error) {
    console.error("Error en getAllDepositos:", error.response?.data || error.message);
    throw error;
  }
};

const depositos = {
  getAllDepositos,
};

export default depositos;
